import { render, staticRenderFns } from "./Streams.vue?vue&type=template&id=2ca21ed0&scoped=true&"
import script from "./Streams.vue?vue&type=script&lang=js&"
export * from "./Streams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca21ed0",
  null
  
)

export default component.exports